function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.57656 7.92314L8.93906 13.2856C9.1364 13.49 9.24559 13.7636 9.24312 14.0477C9.24065 14.3317 9.12672 14.6034 8.92586 14.8043C8.725 15.0051 8.45329 15.1191 8.16924 15.1215C7.8852 15.124 7.61155 15.0148 7.40723 14.8175L1.27881 8.68906C1.07572 8.48591 0.961624 8.21041 0.961624 7.92314C0.961624 7.63588 1.07572 7.36038 1.27881 7.15723L7.40723 1.02881C7.61155 0.831474 7.8852 0.722281 8.16924 0.724749C8.45329 0.727217 8.725 0.84115 8.92586 1.04201C9.12672 1.24287 9.24065 1.51458 9.24312 1.79863C9.24559 2.08267 9.1364 2.35633 8.93906 2.56065L3.57656 7.92314Z",
  fill: "black"
});

function SvgIcDateDesc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateDesc);
export default ForwardRef;